import { FormRow } from '@tanium/react-form';
import { FormSelectInput } from '@tanium/react-form-select-input';
import { Field, FieldProps, FormikErrors } from 'formik';
import get from 'lodash.get';
import IDropdownOption from 'common/IDropdownOption';

type FormDropDownProps = {
  fieldName: string;
  // Note: data-testid does not work with FormSelectInput, must use label and findByLabelText for testing
  label: string;
  description: string;
  options: IDropdownOption[];
  onChange?: (option: IDropdownOption) => void;
  required?: boolean;
  dataTestId?: string;
};

const FormDropDown: React.VFC<FormDropDownProps> = ({
  fieldName,
  label,
  description,
  options,
  onChange,
  required,
  dataTestId,
}) => {
  let computedDataTestId = fieldName;
  if (dataTestId !== undefined) {
    computedDataTestId = dataTestId;
  }
  return (
    <span data-testid={computedDataTestId}>
      <Field name={fieldName}>
        {({ form, field }: FieldProps): React.ReactElement => (
          <FormRow
            label={label}
            description={description}
            labelId={field.name}
            required={required || false}
            errors={(get(form.touched, field.name) && get(form.errors, field.name)) as FormikErrors<string>}
          >
            <FormSelectInput
              {...field}
              aria-label={label}
              value={options?.find((option: IDropdownOption) => option.value === field.value)}
              options={options}
              onChange={(option): void => {
                void form.setFieldValue(field.name, option.value);
                if (onChange) {
                  onChange(option);
                }
              }}
            />
          </FormRow>
        )}
      </Field>
    </span>
  );
};

export default FormDropDown;
